import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { SendOtpPayload, SendOtpResponseData, Userprofile } from '../repositories/auth-repository'

export type LoginData = SendOtpResponseData & SendOtpPayload;

interface AuthState {
    loginData: LoginData;
    userProfile: Userprofile;
    authToken: string;
}

const initialState: AuthState = {
    loginData: {} as LoginData,
    userProfile: {} as Userprofile,
    authToken: '',
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setLoginData: (state, action: PayloadAction<LoginData>) => {
            state.loginData = action.payload
        },
        setUserProfile: (state, action: PayloadAction<Userprofile>) => {
            state.userProfile = action.payload
        },
        setAuthToken: (state, action: PayloadAction<string>) => {
            state.authToken = action.payload
        },
        resetState: () => initialState,
    },
})

export const authActions = authSlice.actions;
export type AuthActions = typeof authSlice.actions;
export default authSlice.reducer;
